module.exports = __webpack_public_path__ + "media/videoinsegt.63c638ae.mp4";